import { render, staticRenderFns } from "./pagePrivacyPolicy.vue?vue&type=template&id=055e7446&"
import script from "./pagePrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./pagePrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./pagePrivacyPolicy.vue?vue&type=style&index=0&id=055e7446&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports